import React from 'react';
import Icon from 'atomic/icon/icon';
import DealerBadgeInterface from 'interfaces/dealer-badge.interface';
import { shouldShowOfferBadge } from 'helpers/get-filters-offers-count';

import './delivery.scss';

export const FREE_DELIVERY_PATTERN_WORDS: string[] = [
    'Darmowa dostawa',
    'Dostawa za 0 zł',
    'Dostawa za 0 zl',
    'Dostarczamy za darmo',
    'Wysyłka za 0 zł',
    'Wysylka za 0 zl',
    'Darmowa wysyłka',
    'Darmowa wysylka',
    'Dostawa0zł',
    'Dostawa 0zł',
    'Dostawa 0 zł',
    'Dostawa gratis',
    'Gratis dostawa',
    'Transport gratis',
    'Wysyłka gratis',
    'Gratis wysyłka',
    'Wysylka gratis',
    'Gratis wysylka',
    'Bezpłatny transport',
    'Bezplatny transport',
    'DARMOWY TRANSPORT'
];

const Delivery: React.FC<{
    offerDescription: string;
    className?: string;
    freeDelivery: DealerBadgeInterface | undefined;
}> = ({ className, freeDelivery, offerDescription }) => {
    if (typeof freeDelivery !== 'undefined' && shouldShowOfferBadge(freeDelivery, offerDescription, FREE_DELIVERY_PATTERN_WORDS)
    ) {
        return (
            <span className={`${className || ''} free-delivery`}>
                <Icon color="primary" name="free-delivery" size={14} />
                {' '}
                Darmowa wysyłka
            </span>
        );
    }

    return null;
};

export default Delivery;
